module.exports = "<article>\r\n\t<div data-teamsite=\"VISION_PROVIDER_LINK\"></div>\r\n</article>";